const jsonURL = {
  updateCouvertsSurJour: "updateCouvertsSurJour",
  updateCouvertsSurHierPerso: "updateCouvertsSurHierPerso",
  updateCouvertsSurMoisPerso: "updateCouvertsSurMoisPerso",
  updateCouvertsMoisPrecedentPerso: "updateCouvertsMoisPrecedentPerso",
  updateCouvertsMemeMoisAnneePrecedentePerso:
    "updateCouvertsMemeMoisAnneePrecedentePerso",
  updateCouvertsSurAnneePerso: "updateCouvertsSurAnneePerso",
  updateCouvertsAnneePrecedentePerso: "updateCouvertsAnneePrecedentePerso",

  updateCaHTSurAujourdhui: "updateCAHTSurAujourdhui",
  updateCASurJour: "updateCASurJour",
  updateCAHTSurJour: "updateCAHTSurJour",
  updateCASurHierPerso: "updateCASurHierPerso",
  updateCAHTSurHierPerso: "updateCAHTSurHierPerso",
  updateCADynamiqueMemeJourSemainePrecedentePerso:
    "updateCADynamiqueMemeJourSemainePrecedentePerso",
  updateCAHTDynamiqueMemeJourSemainePrecedentePerso:
    "updateCAHTDynamiqueMemeJourSemainePrecedentePerso",

  updateCASurMoisPerso: "updateCASurMoisPerso",
  updateCAHTSurMoisPerso: "updateCAHTSurMoisPerso",
  updateCAMoisPrecedentPerso: "updateCAMoisPrecedentPerso",
  updateCAMemeMoisAnneePrecedentePerso: "updateCAMemeMoisAnneePrecedentePerso",
  updateCAHTMoisPrecedentPerso: "updateCAHTMoisPrecedentPerso",
  updateCAHTMemeMoisAnneePrecedentePerso:
    "updateCAHTMemeMoisAnneePrecedentePerso",

  updateCASurSemaine: "updateCASurSemainePerso",
  updateCAHTSurSemaine: "updateCAHTSurSemainePerso",

  updateCASurAnneePerso: "updateCASurAnneePerso",
  updateCAHTSurAnneePerso: "updateCAHTSurAnneePerso",
  updateCAAnneePrecedentePerso: "updateCAAnneePrecedentePerso",
  updateCAHTAnneePrecedentePerso: "updateCAHTAnneePrecedentePerso",

  updateCouvEncDynamiqueJour: "updateCouvEncDynamiqueJour",
  updateCouvEncDynamiqueHierPerso: "updateCouvEncDynamiqueHierPerso",
  updateCouvEncDynamiqueMemeJourSemainePrecedentePerso:
    "updateCouvEncDynamiqueMemeJourSemainePrecedentePerso",

  updateCouvEncDynamiqueSemainePerso: "updateCouvEncDynamiqueSemainePerso",

  updateCouvEncDynamiqueMoisPerso: "updateCouvEncDynamiqueMoisPerso",
  updateCouvEncDynamiqueMoisPrecedentPerso:
    "updateCouvEncDynamiqueMoisPrecedentPerso",
  updateCouvEncDynamiqueMemeMoisAnneePrecedentePerso:
    "updateCouvEncDynamiqueMemeMoisAnneePrecedentePerso",

  updateCouvEncDynamiqueAnneePerso: "updateCouvEncDynamiqueAnneePerso",
  updateCouvEncDynamiqueAnneePrecedentePerso:
    "updateCouvEncDynamiqueAnneePrecedentePerso",

  updateCAParQuartSurJour: "updateCAParQuartSurJour",
  updateCAParMoisSurAnnee: "updateCAParMoisSurAnnee",
  updateCAParJourSurSemaine: "updateCAParJourSurSemaine",
  updateCAParJourSurMois: "updateCAParJourSurMois",

  updateCAHTParQuartSurJour: "updateCAHTParQuartSurJour",
  updateCAHTParMoisSurAnnee: "updateCAHTParMoisSurAnnee",
  updateCAHTParJourSurSemaine: "updateCAHTParJourSurSemaine",
  updateCAHTParJourSurMois: "updateCAHTParJourSurMois",

  updateRemunerationParVendeurServicePerso:
    "updateRemunerationParVendeurServicePerso",
  updateTicketsEtCouvertsServicePerso: "updateTicketsEtCouvertsServicePerso",
  updateTicketsEtCouvertsHeureEtServicePerso:
    "updateTicketsEtCouvertsHeureEtServicePerso",
  updateTicketsEtCouvertsHTServicePerso:
    "updateTicketsEtCouvertsHTServicePerso",
  updateTicketsEtCouvertsHTHeureEtServicePerso:
    "updateTicketsEtCouvertsHTHeureEtServicePerso",

  updateNbTicketsRepasEmployes: "updateNbTicketsRepasEmployes",
  updateMoyensDePaiement: "getMoyensDePaiement",

  getResumeData: "V2/getResumeData",

  getAllData: "getAllData",
  getAllDataHT: "getAllDataHT",

  getTauxCatPeriode: "getTauxCATPeriode",
  getTauxCATParVendeur: "getTauxCATParVendeur",
};

export default jsonURL;
